
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosConvenios {
    numero: string
    ano: string
    idTipo: number
    objeto: string

    constructor() {
        this.limpar()
    }

    limpar(): void {
        this.numero = ''
        this.ano = ''
        this.idTipo = 0
        this.objeto = ''
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.ano)
            data.append("filtroAno", this.ano)
        if (this.numero)
            data.append("filtroNumero", this.numero)
        if (this.idTipo > 0)
            data.append("filtroTipo", String(this.idTipo))
        if (this.objeto)
            data.append("filtroObjeto", this.objeto)
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.ano)
            retorno += '&filtroAno=' + this.ano
        if (this.numero)
            retorno += '&filtroNumero=' + this.numero
        if (this.idTipo > 0)
            retorno += '&filtroTipo=' + String(this.idTipo)
        if (this.objeto)
            retorno += '&filtroObjeto=' + this.objeto
        return retorno
    }
}